import { render, staticRenderFns } from "./bankPos.vue?vue&type=template&id=94854738&scoped=true&"
import script from "./bankPos.vue?vue&type=script&lang=ts&"
export * from "./bankPos.vue?vue&type=script&lang=ts&"
import style0 from "./bankPos.vue?vue&type=style&index=0&id=94854738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94854738",
  null
  
)

export default component.exports